module.exports = __webpack_public_path__ + "img/plusicon.e5ae6280.svg";